/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedNullSearchRelatedItems_viewer = {
    readonly regionalInfo?: ReadonlyArray<{
        readonly regionsByZipCode: ReadonlyArray<{
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly isFavoritesEnabledByLocale: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_viewer">;
    readonly " $refType": "SbSharedNullSearchRelatedItems_viewer";
};
export type SbSharedNullSearchRelatedItems_viewer$data = SbSharedNullSearchRelatedItems_viewer;
export type SbSharedNullSearchRelatedItems_viewer$key = {
    readonly " $data"?: SbSharedNullSearchRelatedItems_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedNullSearchRelatedItems_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedNullSearchRelatedItems_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userZipCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabledByLocale",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FAVORITES"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchRegionalInfo",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "userZipCode"
            }
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "regionsByZipCode",
              "storageKey": null,
              "args": null,
              "concreteType": "RegionsByZipCode",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayName",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '2d5e6251872d3716f5ea473b89c80943';
export default node;
